module.exports = HamburgerMenu = function(el){
  this.element = $(el);
  this.label = $('.js-hamburger-label');
  this.state = $('.js-hamburger-state');
  this.menu = $('.js-hamburger-menu');
  this.win = $(window);
  this.device;
  this.checkDevice();
  this.resize();
  
  if(this.device === 'sp'){
    this.event();
  }
};
HamburgerMenu.prototype.event = function(){
  var self = this;
  var state = false, scrollPos;
  this.label.on('click',function(){
    if(self.state.prop('checked')){
      self.state.prop('checked', false);
    }else{
      self.state.prop('checked', true);
    }
  });
  this.state.on('change',function(){
    if($(this).prop('checked')){
      scrollPos = self.win.scrollTop();
      $('body').addClass('is-fixed').css({'top': -scrollPos});
      self.element.addClass('is-active');
      self.menu.fadeIn('fast');
    }else{
      $('body').removeClass('is-fixed').css({'top': 0});
      window.scrollTo(0, scrollPos);
      self.element.removeClass('is-active');
      self.menu.hide();
    }
  });
  this.menu.find('a').on('click',function(){
    $('body').removeClass('is-fixed').css({'top': 0});
    self.state.prop('checked',false);
    self.element.removeClass('is-active');
    self.menu.hide();
  });
  
};
HamburgerMenu.prototype.resize = function(){
  var self = this;
  this.win.on('resize', function(){
    self.checkDevice();
    if(self.device === 'sp'){
      self.event();
    }else{
      self.state.prop('checked',false);
      self.menu.removeAttr('style');
    }
  });
};
HamburgerMenu.prototype.checkDevice = function(){
  var isSP = this.state.is(':visible');
  if(isSP){
    this.device = 'sp';
  }else{
    this.device = 'pc';
  }
}




//////////////////
// WEBPACK FOOTER
// ./js/_modules/hamburgerMenu.js
// module id = 1
// module chunks = 0